import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://bzlksfnulbzyuhozgezo.supabase.co";
const supabaseAnonKey = "sb_publishable_1R4hZqNkweDbf-zkYQ5KDA_kpk6aSA8";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);